import { Moon, Sun } from 'lucide-react'
import { useUIStore } from '../../stores/uiStore'

export default function ThemeToggle() {
  const { theme, toggleTheme } = useUIStore()

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded hover:bg-editor-hover text-editor-fg/70 hover:text-editor-fg transition-colors"
      title={theme === 'light' ? '切换暗色模式' : '切换亮色模式'}
    >
      {theme === 'light' ? <Moon size={18} /> : <Sun size={18} />}
    </button>
  )
}
